import { validateResponse } from "../../response.js";
import { acceptJson } from "../../shared.js";
import { coordinatesResponseSpec } from "./specs.js";
const getCoordinates = async (apiUrl, request) => {
  return validateResponse(
    coordinatesResponseSpec,
    await fetch(`${apiUrl}/address/coordinates?address=${request.query}`, {
      method: "GET",
      headers: {
        ...acceptJson
      }
    })
  );
};
export {
  getCoordinates
};
//# sourceMappingURL=coordinates.js.map
